<div class="d-flex flex-column p-plus">
  <common-pin-layout
    [pinConfig]="{
      newPasswordType: true,
      type: false,
      forgotPassword: true,
      isBackActionHidden: true,
      isInPage: true,
    }"
    (pinOutput)="getUserPin($event)"
  ></common-pin-layout>

  <ngx-button
    class="mt-hulk"
    [mode]="'form'"
    [fullWidth]="true"
    [size]="'large'"
    [disabled]="isDisableButton()"
    (clickHandler)="onSubmitClicked()"
    [style]="'fill'"
    [leftIcon]="{ name: 'arrow-left', type: 'linear' }"
  >
    تایید و ادامه
  </ngx-button>
</div>
